/**
 * Created by claudio iozzia on 06/07/2017.
 */
import {AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {getMaxPowerXFlyback, getMinPower} from "../../../POWER/acdc/acceptor/acdc__common_acceptor";
import {Acceptor_AcLed_FlyBack} from "./acled_flyback_acceptor";

export class Acceptor_AcLed_QR_FlyBack extends Acceptor_AcLed_FlyBack {

  private acceptSingle_AcLed_QR_Flyback_Pout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const _pOut = spec.spec.value.output.globalOutput; // Global output

    const minPower: number = getMinPower(ic);
    const maxPower: number = getMaxPowerXFlyback(ic, spec);

    const ret = Utils.isValueEmpty(out.voltage) || Utils.isValueEmpty(out.current) || Utils.isValueEmpty(_pOut.power)
      || minPower <= _pOut.power && _pOut.power <= maxPower;
    // console.log("QR FlayBack Pout:", ret, ic, _pOut);
    return ret;
  };

  protected singleOutputP(): AcceptorOutputFn {
    return this.acceptSingle_AcLed_QR_Flyback_Pout;
  }

}
